<div 
  role="status"
  id="{{ identifier }}"
  class="inline-message inline-message--{{ appearance }}">
  
  <!-- icon -->
  <div class="inline-message__icon">

    <lds-icon
      [name]="determineIcon"
      appearance="inherit"
      size="md">
    </lds-icon>

  </div>
  
  <!-- message -->
  <div class="inline-message__content">

    <ng-container *ngIf="showHeadline">
      <div class="content__title">
        {{ headline }}
      </div>
    </ng-container>

    <div class="content__body">
      <div class="row">
        <div class="col body__message">
          <ng-content select="app-inline-message-content"></ng-content>
        </div>
      </div>
    </div>

  </div>
</div>